import {
  Sparkles,
  Droplet,
  Award,
  FlaskConical,
  HandPlatter,
  Brush,
  Utensils,
  Wind,
  ArrowRight,
  MessageCircle,
} from "lucide-react";
import { CATEGORIES, BRANDS } from "../lib/data";
import { useContact } from "../contexts/ContactContext";

const ICONS = {
  Sparkles, Droplet, Award, FlaskConical, HandPlatter, Brush, Utensils, Wind,
};

export const ProductCategories = () => {
  const { openGate } = useContact();
  
  return (
    <section
      id="products"
      data-testid="products-section"
      className="section-pad"
    >
      <div className="msc-container">
        <div className="flex flex-col sm:flex-row sm:items-end sm:justify-between gap-4 mb-10 sm:mb-14">
          <div className="max-w-2xl">
            <span className="badge-trust">Saara Saaman Ek Jagah</span>
            <h2 className="mt-3 font-display font-black text-3xl sm:text-4xl lg:text-5xl text-[#1F2937] leading-tight">
              Hamari <span className="text-[#1E3A8A]">Product Range</span>
            </h2>
            <p className="mt-3 text-[#4B5563] text-base sm:text-lg">
              Ghar, dukaan, ya factory — har safai ki zaroorat ke liye humare
              paas saaman milega. Sasta daam, asli quality.
            </p>
          </div>
          <button
            onClick={() => openGate("Mujhe aap ke products ki full list chahiye, please share karein.")}
            data-testid="products-list-cta"
            className="hidden sm:inline-flex btn-outline"
          >
            <MessageCircle className="w-5 h-5" /> Full List Mango
          </button>
        </div>

        <div
          className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-5"
          data-testid="categories-grid"
        >
          {CATEGORIES.map((c, i) => {
            const Icon = ICONS[c.icon] || Sparkles;
            const accent = i % 2 === 0 ? "#1E3A8A" : "#D97706";
            return (
              <button
                key={c.name}
                onClick={() => openGate(`Hi, mujhe "${c.name}" category ke products ki rate aur availability chahiye.`)}
                data-testid={`category-${c.name.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="card-base p-5 sm:p-6 flex flex-col justify-between min-h-[170px] sm:min-h-[200px] group text-left w-full"
              >
                <div>
                  <div
                    className="w-12 h-12 rounded-xl flex items-center justify-center mb-4 transition-transform group-hover:-translate-y-1"
                    style={{
                      backgroundColor: `${accent}15`,
                      color: accent,
                    }}
                  >
                    <Icon className="w-6 h-6" strokeWidth={2.2} />
                  </div>
                  <h3 className="font-display font-bold text-base sm:text-lg text-[#1F2937]">
                    {c.name}
                  </h3>
                  <p className="text-sm text-[#4B5563] mt-1 leading-snug">
                    {c.desc}
                  </p>
                </div>
                <div className="mt-4 inline-flex items-center gap-1 text-xs font-bold uppercase tracking-wider text-[#25D366]">
                  Contact for Price
                  <ArrowRight className="w-3.5 h-3.5 transition-transform group-hover:translate-x-1" />
                </div>
              </button>
            );
          })}
        </div>

        <div className="sm:hidden mt-7">
          <button
            onClick={() => openGate("Mujhe aap ke products ki full list chahiye, please share karein.")}
            data-testid="products-list-cta-mobile"
            className="btn-outline w-full"
          >
            <MessageCircle className="w-5 h-5" /> Full List Mango
          </button>
        </div>
        {/* Brands List */}
        <div className="mt-12 sm:mt-16 bg-white p-6 sm:p-8 rounded-2xl shadow-sm border border-gray-100 text-center">
          <h3 className="font-display font-bold text-lg sm:text-xl text-[#1F2937] mb-4">
            Top Brands at <span className="text-[#1E3A8A]">Wholesale Rates</span>
          </h3>
          <div className="flex flex-wrap justify-center gap-2 sm:gap-3">
            {BRANDS.map((brand) => (
              <span key={brand} className="px-3 py-1.5 bg-[#FAFAF9] text-[#4B5563] text-sm sm:text-base font-semibold rounded-full border border-gray-200">
                {brand}
              </span>
            ))}
            <span className="px-3 py-1.5 bg-[#F59E0B]/10 text-[#B45309] text-sm sm:text-base font-bold rounded-full border border-[#F59E0B]/20">
              + Many More
            </span>
          </div>
        </div>
      </div>
    </section>
  );
};
